import { render, staticRenderFns } from "./chalet.vue?vue&type=template&id=7e352e8f&"
import script from "./chalet.vue?vue&type=script&lang=js&"
export * from "./chalet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports